<img *ngIf="image" [ngClass]="classList" class="img-thumbnail p-0" [ngStyle]="{'width.px':staticWidth ,'height.px':staticHeight }" [src]="image"   onerror="this.src='../../../../../assets/placeholders/appitem-placeholder.png'"/>
